import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ResponsiveTable } from "@floriday/floriday-ui";
import { useProductCharacteristics } from "../../hooks/useProductCharacteristics";
import { formatDate, formatDateTime } from "../../utils/dateFormat";

export function ProductCharacteristicsTab({
  productId,
}: {
  productId: string;
}) {
  const { t } = useTranslation();
  const { data: characteristics, isLoading } =
    useProductCharacteristics(productId);

  if (isLoading) {
    return null;
  }

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ p: 0 }}>
      <ResponsiveTable striped>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productCharacteristics.code")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productCharacteristics.description")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productCharacteristics.value")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productCharacteristics.startDate")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productCharacteristics.endDate")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productCharacteristics.vbnVersionDate")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {characteristics?.map((item) => (
            <TableRow
              key={`${item.characteristicCode}-${item.characteristicValueCode}`}
            >
              <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{item.characteristicCode}</TableCell>
              <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{item.characteristic?.name}</TableCell>
              <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{item.characteristicValue?.name}</TableCell>
              <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{formatDate(item.startDate)}</TableCell>
              <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{formatDate(item.endDate)}</TableCell>
              <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{formatDateTime(item.vbnChangeDateTime)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </ResponsiveTable>
    </TableContainer>
  );
}
